import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  createClient,
  updateClient,
  getClientById
} from "../api/clientApi";

const ClientForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    ClientName: "",
    PAN: "",
    GSTIN: "",
	AddressLine1: "",
  AddressLine2: "",
  AddressLine3: "",
  Area: "",
  City: "",
  State: "",
  Pincode: ""

  });

  const isEdit = Boolean(id);

  useEffect(() => {
    if (isEdit) {
      loadClient();
    }
  }, [id]);

  const loadClient = async () => {
    try {
      const res = await getClientById(id);
      setForm(res.data);
    } catch (err) {
      console.error("Failed to load client", err);
    }
  };

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (isEdit) {
        await updateClient(id, form);
      } else {
        await createClient(form);
      }
      navigate("/clients");
    } catch (err) {
      console.error("Failed to save client", err);
    }
  };

  return (
    <div className="bg-white p-6 rounded shadow max-w-xl">
      <h1 className="text-xl font-bold mb-4">
        {isEdit ? "Edit Client" : "Add Client"}
      </h1>

      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          value={form.ClientName}
          placeholder="Client Name"
          className="border p-2 w-full"
          onChange={e => handleChange("ClientName", e.target.value)}
          required
        />

        <input
          value={form.PAN}
          placeholder="PAN"
          className="border p-2 w-full"
          onChange={e => handleChange("PAN", e.target.value)}
        />

        <input
          value={form.GSTIN}
          placeholder="GSTIN"
          className="border p-2 w-full"
          onChange={e => handleChange("GSTIN", e.target.value)}
        />

<textarea
  value={form.AddressLine1}
  placeholder="Address Line 1"
  className="border p-2 w-full"
  onChange={e => handleChange("AddressLine1", e.target.value)}
/>

<textarea
  value={form.AddressLine2}
  placeholder="Address Line 2"
  className="border p-2 w-full"
  onChange={e => handleChange("AddressLine2", e.target.value)}
/>

<textarea
  value={form.AddressLine3}
  placeholder="Address Line 3"
  className="border p-2 w-full"
  onChange={e => handleChange("AddressLine3", e.target.value)}
/>

<input
  value={form.Area}
  placeholder="Area"
  className="border p-2 w-full"
  onChange={e => handleChange("Area", e.target.value)}
/>

<input
  value={form.City}
  placeholder="City"
  className="border p-2 w-full"
  onChange={e => handleChange("City", e.target.value)}
/>

<input
  value={form.State}
  placeholder="State"
  className="border p-2 w-full"
  onChange={e => handleChange("State", e.target.value)}
/>

<input
  value={form.Pincode}
  placeholder="Pincode"
  className="border p-2 w-full"
  onChange={e => handleChange("Pincode", e.target.value)}
/>



        <button
          type="submit"
          className="bg-indigo-600 text-white px-4 py-2 rounded"
        >
          Save
        </button>
      </form>
    </div>
  );
};

export default ClientForm;
